import { useContext } from 'react';

import OnboardingTutorialProvider from 'containers/OnboardingTutorialContext';

const useOnboardingTutorial = () => {
  return useContext(OnboardingTutorialProvider.Context);
};

export default useOnboardingTutorial;
